
import browser from '@/utils/browser';
export const setEnv = () => {
    const ENV = {
        isQywx:  browser.qywx,
    } as any;

    if (window) {
        window.ZHY = {
            ENV,
        };
        console.log(window.ZHY.ENV, 'window.ZHY.ENV');
    }

    return ENV as ZHY['ENV'];
};
